import React from "react";
import { render, unmountComponentAtNode } from "react-dom";
import { Provider } from "react-redux";
import configureStore, { history } from "./configureStore";
import AppContainer from "./app/containers/AppContainer";
// import { syncOfflineDocs } from './offline/savedSync'
import { ConnectedRouter } from "connected-react-router";

import "../css/app.scss";
// All of SemanticUI, can be a hot fix for anything missing
// import "semantic-ui-css/semantic.min.css";

// import OfflineNotification from './docgen/components/OfflineNotification'
// TODO: Repurpose this for new data models or just get rid of it
//       altogether since everything is saved as updates happen, not batched
// import OfflineList from './offline/components/OfflineTdlrList'

// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.register('/doc-gen/sw.js')
//     .then(function () { console.log("Service Worker Registered"); });
// }

const store = configureStore();

const node = (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <AppContainer />
    </ConnectedRouter>
  </Provider>
);

const target = document.createElement("main");
target.setAttribute("id", "main_container");
document.body.appendChild(target);

render(node, target);

// Offline notification section
// if ('serviceWorker' in navigator) {

//   window.addEventListener('online', syncOfflineDocs);

//   // Handler for messages coming from the service worker
//   navigator.serviceWorker.addEventListener('message', function (event) {
//     const offlineNotificationTarget = document.getElementById('offline-notification');
//     const close = () => unmountComponentAtNode(offlineNotificationTarget);

//     const offlineNotificationNode = <OfflineNotification msg={event.data} close={close} />
//     render(offlineNotificationNode, offlineNotificationTarget);

//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//   });
// }

// function sendMessage(message) {
//   return new Promise(function (resolve, reject) {
//     var messageChannel = new MessageChannel();
//     messageChannel.port1.onmessage = function (event) {
//       event.data.error ?
//         reject(event.data.error)
//         : resolve(event.data);
//     };

//     navigator.serviceWorker.controller.postMessage(message, [messageChannel.port2]);
//   });
// }
